import storage from 'local-storage';


const storeForms = _.debounce(
    function () {
        let state = app.store.getState(),
            data = {
                __VERSION__,
                data: {
                    drafts: state.forms.drafts,
                    uploading: state.forms.uploading,
                },
            };
        storage.set('forms', JSON.stringify(data));
    },
    {
        leading: true,
        trailing: true,
        wait: 1000,
        maxWait: 5000,
    }
);

export default function () {
    // Load currently saved state
    let payload = storage.get('forms');
    if (payload) {
        try {
            payload = JSON.parse(payload);
            if (payload) {
                app.store.dispatch(app.actions.forms.loadPersistedData(payload));
            }
        } catch (err) {
            console.error(err);
        }
    }

    // Save when changes happen
    let unobserveFormsPersister = app.store.observe(state => state.forms, storeForms);
    app.onShutdown(unobserveFormsPersister);
}
